export const statusButtonText = (value, t) => {
  switch (value) {
    case 2:
      return t("global.send_booking", "Send booking")
    case 3:
      return t("global.cancel", "Cancel")
    case 4:
      return null
    case 5:
      return null
    default:
      return t("global.send_booking", "Send booking")
  }
}

export const statusButtonColor = (value) => {
  switch (value) {
    case 2:
      return "primary"
    case 3:
      return "error"
    case 4:
      return null
    case 5:
      return null
    default:
      return "primary"
  }
}

export const statusSubText = (value, t) => {
  switch (value.status) {
    case 3:
      return `${t(
        "issuereports.if_you_cancel_the_order_a_confirmation_is_send",
        "If you cancel the order, a confirmation will be sent to"
      )} ${value.customerName}.`
    case 6:
      return t("issuereports.workorder_is_canceled", "Workorder is canceled")
    default:
      return null
  }
}

export const statusAlertText = (value, t) => {
  switch (value) {
    case 1:
      return t(
        "issuereports.would_you_like_to_send_workorders_to_email",
        "Would you like to send work orders to the specified email?"
      )
    case 2:
      return t("issuereports.do_you_want_to_cancel_a_workorder", "Do you want to cancel a work order?")
    case 3:
      return t("issuereports.do_you_want_to_cancel_a_workorder", "Do you want to cancel a work order?")
    case 4:
      return t(
        "issuereports.do_you_want_to_close_and_end_workorder",
        "Do you want to close and end work orders?"
      )
    default:
      return t(
        "issuereports.do_you_want_to_close_and_end_workorder",
        "Do you want to close and end work orders?"
      )
  }
}
